import { NotTranslated } from '@execonline-inc/translations';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { reportUrl } from '../../ClientRoutes';
import { findLink } from '../../LinkyLinky';
import { ReportResource } from '../../ReportsStore/Types';
import Beta from '../Report/Beta';

interface Props {
  reportResource: ReportResource;
}

const ReportItem: React.FC<Props> = ({ reportResource }) => {
  const { payload, links } = reportResource;
  return (
    <div
      className={clsx(
        'mb-8 h-80 w-full rounded-md overflow-hidden border-1 border-solid border-gray-200 md:w-[48%] lg:w-[32%]',
      )}
    >
      <NavLink to={reportUrl(payload.id)}>
        <img
          className={clsx(`h-48 bg-gray-10 bg-cover bg-no-repeat mx-auto`)}
          src={findLink('asset', links)
            .map((link) => link.href)
            .getOrElseValue('https://place-puppy.com/600x300')}
          alt={`A thumbnail preview of sample charts included the ${payload.name} reports.`}
        />
      </NavLink>
      <div>
        <div className="mt-7 ml-7 flex">
          <NavLink
            to={reportUrl(payload.id)}
            className={clsx('block text-xl font-semibold leading-7 hover:opacity-80')}
          >
            <NotTranslated text={payload.name} />
          </NavLink>
          <Beta beta={payload.beta} />
        </div>
        <p className="mt-3 mb-14 ml-7 text-sm font-normal leading-4">
          <NotTranslated text={payload.description} />
        </p>
      </div>
    </div>
  );
};

export default observer(ReportItem);
